import _googleAnalyticsPlugin from '@analytics/google-analytics';

export default function googleAnalyticsPlugin(userConfig) {
  let _super = _googleAnalyticsPlugin(userConfig);
  let superInitialize = _super.initialize;

  _super.initialize = function (pluginApi) {
    let result = superInitialize(pluginApi);

    if (pluginApi.require) {
      pluginApi.require.forEach((plugin) => {
        window.ga('require', plugin);
      });
    }

    if (pluginApi.sendHitTask === false) {
      window.ga('set', 'sendHitTask', null);
    }

    return result;
  };

  return _super;
}
